export const CAMPAIGN_TABLE_APPCUES_ID = {
    INSIGHT_HEADER: 'CAMPAIGN_TABLE_INSIGHT_HEADER',
};

export const CAMPAIGN_TABLE_HEADER_TEXTS = {
    TITLE: 'Campaigns Table',
    SUBTITLE: 'A deep dive view of your campaigns.',
    PLACEHOLDER: 'Search campaigns...',
};
